import * as React from 'react';
import { inject, observer } from 'mobx-react';
import makeCancelable, { CanceledError } from 'core/util/cancelablePromise';
import { Box, Button, EmptyState } from 'core/components';
import SidebarItem from 'app/views/hybrid/maps/components/popovers/SidebarItem';
import SearchableTable from 'app/views/hybrid/maps/components/SearchableTable';

@inject('$hybridMap')
@observer
export default class VNetGatewayLearnedRoutes extends React.Component {
  state = {
    loading: true,
    isPoppedOut: false,
    data: null
  };

  componentDidUpdate(prevProps, prevState) {
    const { nodeData } = this.props;
    const { data, isPoppedOut } = this.state;
    const popOutChanged = prevState.isPoppedOut !== isPoppedOut;

    if (prevProps.nodeData?.id !== nodeData?.id || (data === null && popOutChanged)) {
      // if we have the sidebar open and switch to a new load balancer or change the time range, fetch for new data
      this.fetchLearnedRoutes();
    }
  }

  componentWillUnmount() {
    if (this.request) {
      this.request.cancel();
    }
  }

  fetchLearnedRoutes = () => {
    const { $hybridMap, nodeData } = this.props;

    this.setState({ loading: true }, () => {
      this.request = makeCancelable($hybridMap.getVNetGatewayLearnedRoutes({ id: nodeData.id }));

      this.request.promise
        .then((response) => {
          this.setState({ loading: false, data: response });
        })
        .catch((e) => {
          if (e instanceof CanceledError === false) {
            this.setState({ loading: false }, () => console.error(e));
          }
        });
    });
  };

  handleExpandChange = (isOpenOrPoppedOut) => {
    const { data } = this.state;

    if (isOpenOrPoppedOut && data === null) {
      // fetch for data when expanding for the first time
      this.fetchLearnedRoutes();
    }
  };

  handlePopOutChange = (isPoppedOut) => {
    this.setState({ isPoppedOut }, this.handleExpandChange);
  };

  handlePanelRefresh = (e) => {
    e.stopPropagation();
    this.fetchLearnedRoutes();
  };

  get emptyState() {
    return <EmptyState title="No Results Found" icon="flow-linear" />;
  }

  get columns() {
    const { isPoppedOut } = this.state;
    const minimizedColumns = [
      {
        name: 'network',
        label: 'Network'
      },

      {
        name: 'nextHop',
        label: 'Next Hop'
      },

      {
        name: 'localAddress',
        label: 'Local Address'
      },

      {
        name: 'sourcePeer',
        label: 'Source Peer'
      },

      {
        name: 'origin',
        label: 'Origin'
      },

      {
        name: 'asPath',
        label: 'AS Path'
      }
    ];

    if (isPoppedOut) {
      return minimizedColumns.concat({
        name: 'weight',
        label: 'Weight'
      });
    }

    return minimizedColumns;
  }

  render() {
    const { popoutTitle } = this.props;
    const { loading, data } = this.state;

    return (
      <SidebarItem
        excludeFormProps
        title="Learned Routes"
        dialogProps={{ width: 1300 }}
        popoutTitle={popoutTitle}
        icon="flow-linear"
        navigationButtons={<Button icon="refresh" color="success" onClick={this.handlePanelRefresh} small minimal />}
        onExpandChange={this.handleExpandChange}
        onPopOutChange={this.handlePopOutChange}
      >
        <Box>
          {this.popOutHeader}
          <SearchableTable
            collectionOptions={{ sortState: { field: 'name', direction: 'asc' } }}
            height={240}
            loading={loading}
            columns={this.columns}
            data={data || []}
            emptyState={this.emptyState}
            stickyHeader
          />
        </Box>
      </SidebarItem>
    );
  }
}
